// Contrats de l'assistant de recherche (add-on 24) : réglages, question, réponse et retour.
// Rien de la question ni de la réponse n'est conservé : ces schémas ne décrivent que l'échange.
import { z } from 'zod';
import { ROLES_GALERIE, roleGalerieSchema } from './permissions/roles.js';
const champsReglages = {
    actif: z.boolean(),
    /** Dictée du navigateur : l'audio part en général chez Google ou Apple. */
    dicteeWeb: z.boolean(),
    /** Lot C : lecture du texte des documents. */
    lectureDocuments: z.boolean(),
    /** Bouton « Approfondir » et repli automatique en Sonnet. */
    approfondir: z.boolean(),
    roles: z
        .array(roleGalerieSchema)
        .max(ROLES_GALERIE.length)
        .refine((roles) => new Set(roles).size === roles.length, 'Un rôle ne peut figurer deux fois.'),
};
export const reglagesAssistantRechercheSchema = z.strictObject(champsReglages);
export const REGLAGES_RECHERCHE_DEFAUT = {
    actif: true,
    dicteeWeb: false,
    lectureDocuments: false,
    approfondir: true,
    roles: ['direction', 'equipe', 'comptable'],
};
export const modificationReglagesRechercheSchema = z
    .strictObject(champsReglages)
    .partial()
    .extend({ version: z.int().nonnegative() });
export const reponseReglagesRechercheSchema = reglagesAssistantRechercheSchema.extend({
    version: z.int().nonnegative(),
    /** Questions posées ce mois civil à Paris, toutes personnes confondues. */
    questionsDuMois: z.int().nonnegative(),
});
export const QUESTION_RECHERCHE_MAX = 500;
export const REPONSE_RECHERCHE_MAX = 600;
/** Un échange précédent, gardé par l'écran et renvoyé par le client : jamais par le serveur. */
export const echangeRechercheSchema = z.strictObject({
    question: z.string().trim().min(1).max(QUESTION_RECHERCHE_MAX),
    reponse: z.string().trim().max(REPONSE_RECHERCHE_MAX),
});
export const questionRechercheSchema = z.strictObject({
    question: z.string().trim().min(1).max(QUESTION_RECHERCHE_MAX),
    historique: z.array(echangeRechercheSchema).max(6).default([]),
    approfondir: z.boolean().optional(),
});
export const TYPES_SOURCE_RECHERCHE = [
    'oeuvre',
    'artiste',
    'contact',
    'demande',
    'exposition',
    'facture',
    'affaire',
    'document',
];
export const ETATS_ETAPE_RECHERCHE = ['ok', 'refuse', 'erreur'];
export const reponseRechercheSchema = z.strictObject({
    reponse: z.string().max(REPONSE_RECHERCHE_MAX),
    /** Liens relatifs à la galerie (`/oeuvres/<id>`), construits par le serveur. */
    sources: z
        .array(z.strictObject({
        type: z.enum(TYPES_SOURCE_RECHERCHE),
        id: z.string(),
        libelle: z.string(),
        lien: z.string(),
    }))
        .max(8),
    etapes: z.array(z.strictObject({
        outil: z.string(),
        etat: z.enum(ETATS_ETAPE_RECHERCHE),
        nombre: z.int().nonnegative().optional(),
    })),
    /** Éléments non ouverts à la personne : comptés, jamais nommés. */
    masques: z.int().nonnegative().optional(),
    /** Demande d'action : l'écran où la faire, d'après une table fixe. */
    ecran: z.string().optional(),
    appelId: z.string(),
    niveau: z.enum(['rapide', 'approfondi']),
});
export const MOTIFS_RETOUR_RECHERCHE = ['faux', 'incomplet', 'lent', 'autre'];
export const retourRechercheSchema = z.strictObject({
    utile: z.boolean(),
    motif: z.enum(MOTIFS_RETOUR_RECHERCHE).optional(),
});
//# sourceMappingURL=assistant-recherche.js.map